module.exports = {template: '<svg width="20" height="21" viewBox="0 0 20 21" xmlns="http://www.w3.org/2000/svg"><path d="M19.266 9.61H2.437l8.72-8.72-.891-.89L0 10.266l10.266 10.218.89-.89-8.719-8.719h16.829z" fill-rule="evenodd"/></svg>'};


//////////////////
// WEBPACK FOOTER
// ./static/svg/icon_arrow_left.svg
// module id = 1181
// module chunks = 1